/* 表示済みのFAQ記事と公式手順を検索する。別索引や外部通信は使わない。 */
(function () {
  'use strict';
  if (window.skBfaqSearchLoaded) return;
  window.skBfaqSearchLoaded = true;

  function normalize(value) {
    return String(value || '').normalize('NFKC').toLowerCase()
      .replace(/[‐‑‒–—−]/g, '-').replace(/wi[\s-]*fi/g, 'wifi').trim();
  }
  function compact(value) { return normalize(value).replace(/[\s_-]+/g, ''); }
  function words(value) { return normalize(value).split(/\s+/).filter(Boolean).map(compact); }
  function matches(text, terms) { return terms.every(function (term) { return text.indexOf(term) !== -1; }); }
  function isCode(value) {
    var code = normalize(value).replace(/^hms[\s:_-]*/, '');
    return /^[a-f0-9\s_-]+$/.test(code) && /\d/.test(code) && compact(code).length >= 4;
  }
  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }
  function readQuery(key) { return new URL(location.href).searchParams.get(key) || ''; }
  function saveQuery(key, value, anchor) {
    var url = new URL(location.href);
    if (value.trim()) url.searchParams.set(key, value.trim()); else url.searchParams.delete(key);
    if (anchor && value.trim()) url.hash = anchor;
    try { history.replaceState(history.state, '', url); } catch (e) { /* 検索操作は継続する。 */ }
  }

  function hubEntries() {
    var entries = new Map();
    function add(link, title, context, kind) {
      if (!link) return;
      var url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/^\/(blogs\/faq\/|pages\/bambu-faq-)/.test(url.pathname)) return;
      var id = url.pathname;
      var entry = entries.get(id);
      if (!entry) {
        entry = { href: link.href, title: title.trim(), kind: kind, titleKey: compact(title), contexts: [] };
        entries.set(id, entry);
      }
      entry.contexts.push(compact(title + ' ' + context));
    }
    document.querySelectorAll('.sk-bhub-card__a').forEach(function (link) {
      var title = link.querySelector('.sk-bhub-card__name');
      var kana = link.querySelector('.sk-bhub-card__kana');
      if (title) add(link, title.textContent, kana ? kana.textContent : '', '機種別FAQ');
    });
    document.querySelectorAll('.sk-bhub-sym__item, .sk-bhub-guide').forEach(function (group) {
      var heading = group.querySelector('h3');
      var lead = group.querySelector('.sk-bhub-sym__lead, .sk-bhub-guide__note');
      var context = (heading ? heading.textContent : '') + ' ' + (lead ? lead.textContent : '');
      group.querySelectorAll('a').forEach(function (link) { add(link, link.textContent, context, 'FAQ記事'); });
    });
    document.querySelectorAll('.sk-bhub-qf__a').forEach(function (answer) {
      var question = answer.previousElementSibling;
      var link = answer.querySelector('a');
      if (link) add(link, link.textContent.replace(/^詳しく読む:\s*/, ''), question ? question.textContent : '', 'FAQ記事');
    });
    return Array.from(entries.values());
  }

  function hub(form) {
    var entries = hubEntries();
    if (!entries.length) return null;
    var input = form.querySelector('input[type="search"]');
    var results = form.querySelector('.sk-bfaq-search__results');
    var list = results.querySelector('ul');
    var status = results.querySelector('[role="status"]');
    var empty = results.querySelector('.sk-bfaq-search__empty');
    var more = results.querySelector('[data-search-more]');
    var hms = results.querySelector('.sk-bfaq-search__hms a');
    var limit = 6;
    var found = [];
    form.querySelector('label').textContent = form.dataset.searchLabel;
    input.placeholder = form.dataset.searchPlaceholder;
    var note = form.querySelector('.sk-bhub-hero__search-n');
    if (note) note.textContent = form.dataset.searchNote;
    form.querySelector('.sk-bfaq-search__tools').hidden = false;

    function show(reset) {
      if (reset) limit = 6;
      var term = input.value.trim();
      var terms = words(term);
      var code = isCode(term);
      results.hidden = !terms.length;
      list.replaceChildren();
      var target = new URL(form.action);
      target.searchParams.set('q', term);
      hms.href = target.href;
      found = terms.length && !code ? entries.filter(function (entry) {
        return entry.contexts.some(function (text) { return matches(text, terms); });
      }).sort(function (a, b) {
        return Number(matches(b.titleKey, terms)) - Number(matches(a.titleKey, terms));
      }) : [];
      found.slice(0, limit).forEach(function (entry) {
        var li = node('li');
        li.appendChild(node('span', 'sk-bfaq-search__kind', entry.kind));
        var link = node('a', '', entry.title);
        link.href = entry.href;
        li.appendChild(link);
        list.appendChild(li);
      });
      status.textContent = !terms.length ? '' : code ? 'エラーコードをHMS逆引きで探せます。'
        : '「' + term + '」に関連する ' + found.length + ' 件' + (found.length > limit ? '（' + limit + '件を表示）' : '');
      empty.hidden = !terms.length || code || found.length > 0;
      more.hidden = found.length <= limit;
    }
    more.addEventListener('click', function () {
      var previous = limit;
      limit += 6;
      show(false);
      var next = list.children[previous];
      if (next) next.querySelector('a').focus({ preventScroll: true });
    });
    return { key: 'q', apply: function () { show(true); }, navigate: function () { return isCode(input.value); } };
  }

  function guides(form) {
    var section = form.closest('.sk-bfaq-official');
    var groups = Array.from(section.querySelectorAll('.sk-bfaq-og')).map(function (details) {
      var badge = node('span', 'sk-bfaq-search__group-hit');
      details.querySelector('summary').appendChild(badge);
      return { el: details, open: details.open, badge: badge, rows: Array.from(details.querySelectorAll('li')).map(function (li) {
        return { el: li, text: compact(li.textContent) };
      }) };
    });
    if (!groups.length) return null;
    var input = form.querySelector('input');
    var status = form.querySelector('[role="status"]');
    var empty = form.querySelector('.sk-bfaq-search__empty');
    var filtering = false;
    var total = groups.reduce(function (n, group) { return n + group.rows.length; }, 0);
    return { key: 'guide_q', anchor: section.id, apply: function () {
      var terms = words(input.value);
      var shown = 0;
      if (terms.length && !filtering) groups.forEach(function (group) { group.open = group.el.open; });
      groups.forEach(function (group) {
        var count = 0;
        group.rows.forEach(function (row) {
          row.el.hidden = !matches(row.text, terms);
          if (!row.el.hidden) count++;
        });
        group.el.hidden = count === 0;
        if (terms.length) group.el.open = count > 0;
        else if (filtering) group.el.open = group.open;
        group.badge.textContent = terms.length ? '該当 ' + count + ' 件' : '';
        shown += count;
      });
      filtering = terms.length > 0;
      status.textContent = filtering ? '「' + input.value.trim() + '」で ' + shown + ' / ' + total + ' 件' : total + ' 件の公式手順から探せます。';
      empty.hidden = shown > 0;
    } };
  }

  function init(root) {
    root.querySelectorAll('[data-bfaq-search]').forEach(function (form) {
      if (form.dataset.searchReady) return;
      var controller = form.dataset.bfaqSearch === 'hub' ? hub(form) : guides(form);
      if (!controller) return;
      form.dataset.searchReady = 'true';
      form.hidden = false;
      var input = form.querySelector('input[type="search"]');
      var clear = form.querySelector('[data-search-clear]');
      var timer;
      var composing = false;
      function apply(write) {
        clearTimeout(timer);
        controller.apply();
        clear.hidden = !input.value;
        if (write) saveQuery(controller.key, input.value, controller.anchor);
      }
      function restore() { input.value = readQuery(controller.key); apply(false); }
      input.addEventListener('compositionstart', function () { composing = true; clearTimeout(timer); });
      input.addEventListener('compositionend', function () { composing = false; apply(true); });
      input.addEventListener('input', function () {
        clearTimeout(timer);
        if (!composing) timer = setTimeout(function () { apply(true); }, 160);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && (composing || e.isComposing || e.keyCode === 229)) { e.preventDefault(); return; }
        if (e.key === 'Escape' && !composing) { input.value = ''; apply(true); }
      });
      form.addEventListener('submit', function (e) {
        if (composing || e.isComposing) { e.preventDefault(); return; }
        if (controller.navigate && controller.navigate()) return;
        e.preventDefault(); apply(true); input.blur();
      });
      clear.addEventListener('click', function () { input.value = ''; apply(true); input.focus(); });
      window.addEventListener('popstate', restore);
      restore();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function () { init(document); });
})();
